module.exports = __webpack_public_path__ + "static/media/dcid.130f8e72.jpg";